import React from 'react';
import { Modal as HeroModal, ModalContent, ModalHeader, ModalBody } from '@heroui/react';
// Microblog-LMS 스타일과 API를 유지하는 래퍼
export default function Modal(param) {
    var isOpen = param.isOpen, onClose = param.onClose, title = param.title, _param_width = param.width, width = _param_width === void 0 ? 'lg' : _param_width, children = param.children;
    return /*#__PURE__*/ React.createElement(HeroModal, {
        isOpen: isOpen,
        onClose: onClose,
        size: width
    }, /*#__PURE__*/ React.createElement(ModalContent, null, title && /*#__PURE__*/ React.createElement(ModalHeader, null, title), /*#__PURE__*/ React.createElement(ModalBody, null, children)));
}
